import React from 'react';

import { ArrowRight } from 'lucide-react';

import { JourneyWorldIcon } from './JourneyWorldIcon';

import { IMcsaTransition, IMcsaWorld } from '../../../../types/mcsa.interface';
import { MCSA_JOURNEY_COPY } from '../../../../helpers/mcsa-journey.copy';
import { MCSA_WORLD_THEME } from '../../../../helpers/mcsa-world.theme';

interface JourneyTransitionProps {
    world: IMcsaWorld;
    copy: IMcsaTransition;
    onContinue: () => void;
    onBack: () => void;
}

export const JourneyTransition = (props: JourneyTransitionProps) => {
    const { world, copy, onContinue, onBack } = props;
    const accent = MCSA_WORLD_THEME[world.key].accent;

    return (
        <div className={`mcsa_journey_stage mcsa_journey_stage--${world.key}`}>
            <div className='mcsa_journey_panel'>
                <div className='mcsa_journey_panel__emoji'>{copy.emoji}</div>
                <p className='mcsa_journey_panel__eyebrow' style={{ color: accent }}>{world.name}</p>
                <h2 className='text-light color--primary'>{copy.title}</h2>
                <p className='mcsa_journey_panel__body'>{copy.body}</p>
                <button
                    type='button'
                    className='btn btn--lg btn--radius-full btn--primary mcsa_journey_panel__cta'
                    style={{ backgroundColor: accent }}
                    onClick={onContinue}
                >
                    <span>{copy.cta}</span>
                    <ArrowRight />
                </button>
                <button type='button' className='mcsa_journey_panel__back' onClick={onBack}>
                    ← {MCSA_JOURNEY_COPY.back_to_map}
                </button>
            </div>
        </div>
    );
};

interface JourneyAffirmProps {
    world: IMcsaWorld;
    isLast: boolean;
    onContinue: () => void;
}

export const JourneyAffirm = (props: JourneyAffirmProps) => {
    const { world, isLast, onContinue } = props;
    const accent = MCSA_WORLD_THEME[world.key].accent;
    const cta = world.wildcard_key
        ? MCSA_JOURNEY_COPY.affirm_continue
        : isLast
            ? MCSA_JOURNEY_COPY.affirm_finish
            : MCSA_JOURNEY_COPY.affirm_almost;

    return (
        <div className={`mcsa_journey_stage mcsa_journey_stage--${world.key}`}>
            <div className='mcsa_journey_panel'>
                <div className='mcsa_journey_panel__icon' style={{ background: accent }}>
                    <JourneyWorldIcon worldKey={world.key} />
                </div>
                <p className='mcsa_journey_panel__eyebrow' style={{ color: accent }}>
                    {world.name} · {MCSA_JOURNEY_COPY.complete}
                </p>
                <h2 className='text-light color--primary'>{MCSA_JOURNEY_COPY.affirm_title}</h2>
                <p className='mcsa_journey_panel__body'>{world.affirmation}</p>
                <div className='mcsa_journey_panel__lock'>
                    <p>{MCSA_JOURNEY_COPY.affirm_lock}</p>
                </div>
                <button
                    type='button'
                    className='btn btn--lg btn--radius-full btn--primary mcsa_journey_panel__cta'
                    style={{ backgroundColor: accent }}
                    onClick={onContinue}
                >
                    <span>{cta}</span>
                    <ArrowRight />
                </button>
            </div>
        </div>
    );
};
